import moment from "moment";

export function formatDateTime(inputDate) {
    const date = new Date(inputDate);

    const formattedDate = date.toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });

    return formattedDate;
}

export function formatDateFromFRFormat(inputDate) {
    const dateParts = inputDate.split(' '); // Séparation de la date et de l'heure
    const [day, month, year] = dateParts[0].split('/');
    const [hour, minute, second] = dateParts[1].split(':');

    // Création de l'objet Date
    const dateObj = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);

    // Extraction des différentes parties de la date
    const formattedDate = `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${dateObj
        .getDate()
        .toString()
        .padStart(2, '0')} ${dateObj.getHours()
        .toString()
        .padStart(2, '0')}:${dateObj.getMinutes()
        .toString()
        .padStart(2, '0')}:${dateObj.getSeconds()
        .toString()
        .padStart(2, '0')}`;

    return formattedDate;
}

/**
 * Renvoie la date et l'heure actuelle au format jour/mois/année à heure:minute
 * @param {string} datetime 
 * @returns {string}
 * @example "2021-08-02T14:30:00"
 */
export function getFormattedDateTime(datetime) {
    return moment(datetime).format('DD/MM/YYYY [à] HH[h]mm');
}